/* --------------------------------------------------------------------
   TØTE — Build your set page (Kopstorm)
   Engine for sections/kv-bundle-builder.liquid

   Pricing model
   -------------
   mode "second_bag": every second bag is discounted by cfg.secondPct.
   Bags are sorted by price descending and paired, so the discount always
   lands on the CHEAPER bag of each pair. That is exactly how a Shopify
   automatic Buy X Get Y discount on an "All bags" collection behaves, so
   the amounts shown here match the checkout for any combination of
   collections (TØTE, Stitched, SIV, ALTA, ALVA).

   mode "ladder": bags sorted by price descending; the 2nd most expensive
   bag gets cfg.ladder[0] off, the 3rd cfg.ladder[1], the 4th and every
   further bag the last entry. Mirrors the Kopstorm Discount Function.

   mode "tiers": legacy quantity ladder, one percentage on every bag.

   Accessories: a fixed add-on price per group when cfg.addonMode is
   "fixed", the shop is in its base currency and the card carries a
   data-set-price. Otherwise cfg.addonPct.

   Every amount is a PREVIEW. Money off is enforced at checkout by the
   automatic discount or the Discount Function keyed on the _kv_bundle
   line properties.
   -------------------------------------------------------------------- */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.kvBbReady === '1') return;
    root.dataset.kvBbReady = '1';

    var cfgEl = root.querySelector('[data-kv-bb-config]');
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var moneyFormat = root.dataset.money || '\u20ac{{amount_with_comma_separator}}';
    var mode = cfg.mode === 'tiers' ? 'tiers' : (cfg.mode === 'ladder' ? 'ladder' : 'second_bag');
    var secondPct = parseInt(cfg.secondPct, 10) || 0;
    var ladder = (cfg.ladder || []).map(function (n) { return parseInt(n, 10) || 0; });
    function ladderPct(i) { /* i = 0-based position, price descending */
      if (i < 1 || !ladder.length) return 0;
      return ladder[Math.min(i - 1, ladder.length - 1)];
    }

    var bar = root.querySelector('[data-kv-bb-bar]');
    var slotsEl = root.querySelector('[data-kv-bb-slots]');
    var slotRows = root.querySelectorAll('[data-kv-bb-slotrow]');
    var linesEl = root.querySelector('[data-kv-bb-lines]');
    var emptyEl = root.querySelector('[data-kv-bb-empty]');
    var msgEls = root.querySelectorAll('[data-kv-bb-msg]');
    var fillEls = root.querySelectorAll('[data-kv-bb-fill]');
    var giftEls = root.querySelectorAll('[data-kv-bb-gift]');
    var shipEls = root.querySelectorAll('[data-kv-bb-ship]');
    var savingEls = root.querySelectorAll('[data-kv-bb-saving]');
    var origEls = root.querySelectorAll('[data-kv-bb-orig]');
    var totalEls = root.querySelectorAll('[data-kv-bb-total]');
    var ctaEls = root.querySelectorAll('[data-kv-bb-cta]');
    var ctaLabelEls = root.querySelectorAll('[data-kv-bb-cta-label]');
    var ctaDefault = ctaLabelEls.length ? ctaLabelEls[0].textContent : 'Add set to cart';

    function each(list, fn) { Array.prototype.forEach.call(list, fn); }
    function setText(list, t) { each(list, function (el) { el.textContent = t; }); }
    function setHidden(list, h) { each(list, function (el) { el.hidden = h; }); }
    function setCtaLabel(t) { setText(ctaLabelEls, t); }

    /* state: variantId -> { qty, price, compare, title, img, addon, setPrice } */
    var state = {};

    function formatMoney(cents) {
      var amount = cents / 100;
      var m = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
      var key = m ? m[1] : 'amount';
      var comma = key.indexOf('comma_separator') !== -1;
      /* A discounted line is computed in minor units and is often not a whole amount.
         The shop format drops the minor units, so the page quoted less than the cart
         charged on 42% of possible sets. Honour the format when the amount is whole and
         show the minor units when it is not: the page can then never under-quote. */
      var whole = (cents % 100) === 0;
      var value = (key.indexOf('no_decimals') !== -1 && whole)
        ? String(Math.round(amount))
        : amount.toFixed(2);
      if (comma) value = value.replace('.', ',');
      return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, value).replace(/<[^>]*>/g, '');
    }

    function escapeHtml(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    /* ---------------- cards ---------------- */
    var cards = root.querySelectorAll('[data-kv-item]');
    Array.prototype.forEach.call(cards, function (card) {
      var addBtn = card.querySelector('[data-kv-add]');
      var qtyEl = card.querySelector('[data-kv-qty]');
      var minus = card.querySelector('[data-kv-minus]');
      var plus = card.querySelector('[data-kv-plus]');
      var select = card.querySelector('[data-kv-variant-select]');
      var priceEl = card.querySelector('[data-kv-card-price]');
      if (!addBtn || addBtn.disabled) return;

      function key() { return card.dataset.variant; }

      function setQty(q) {
        q = Math.max(0, Math.min(20, q));
        var k = key();
        if (q === 0) {
          delete state[k];
        } else {
          state[k] = {
            qty: q,
            price: parseInt(card.dataset.price, 10) || 0,
            compare: parseInt(card.dataset.compare, 10) || 0,
            title: card.dataset.title || '',
            img: card.dataset.img || '',
            addon: card.dataset.addon === '1',
            setPrice: parseInt(card.dataset.setPrice, 10) || 0
          };
        }
        if (qtyEl) qtyEl.textContent = String(q);
        render();
      }

      addBtn.addEventListener('click', function () { setQty((state[key()] ? state[key()].qty : 0) + 1); });
      if (plus) plus.addEventListener('click', function () { setQty((state[key()] ? state[key()].qty : 0) + 1); });
      if (minus) minus.addEventListener('click', function () { setQty((state[key()] ? state[key()].qty : 0) - 1); });

      if (select) {
        select.addEventListener('change', function () {
          var opt = select.options[select.selectedIndex];
          if (!opt) return;
          var prevQty = state[key()] ? state[key()].qty : 0;
          if (prevQty > 0) delete state[key()];
          card.dataset.variant = opt.value;
          card.dataset.price = opt.dataset.price || card.dataset.price;
          card.dataset.compare = opt.dataset.compare || '0';
          if (priceEl) {
            var p = parseInt(card.dataset.price, 10) || 0;
            var c = parseInt(card.dataset.compare, 10) || 0;
            priceEl.innerHTML = (c > p ? '<s>' + formatMoney(c) + '</s> ' : '') + '<span>' + formatMoney(p) + '</span>';
          }
          if (prevQty > 0) setQty(prevQty); else render();
        });
      }
    });

    /* ---------------- computation ---------------- */

    /* Expand the selection into one entry per unit. */
    function unitsOf(addon) {
      var out = [];
      Object.keys(state).forEach(function (k) {
        var it = state[k];
        if (!!it.addon !== !!addon) return;
        for (var i = 0; i < it.qty; i++) {
          out.push({ key: k, price: it.price, compare: it.compare, title: it.title, img: it.img, setPrice: it.setPrice });
        }
      });
      return out;
    }

    function accessoryPrice(unit) {
      if (cfg.addonMode === 'fixed' && cfg.baseCurrency && unit.setPrice > 0 && unit.setPrice < unit.price) {
        return unit.setPrice;
      }
      var pct = parseInt(cfg.addonPct, 10) || 0;
      if (pct <= 0) return unit.price;
      return unit.price - Math.round(unit.price * pct / 100);
    }

    function compute() {
      var bags = unitsOf(false);
      var addons = unitsOf(true);

      /* Bags sorted high to low: the discount lands on the cheaper of each pair. */
      bags.sort(function (a, b) { return b.price - a.price; });

      var tierPct = 0, nextQty = 0, nextPct = 0;
      if (mode === 'tiers') {
        var t1 = cfg.tier1 || { qty: 0, pct: 0 };
        var t2 = cfg.tier2 || { qty: 0, pct: 0 };
        var t2on = t2.qty > t1.qty && t2.pct > 0;
        if (t1.qty > 0 && bags.length >= t1.qty) tierPct = t1.pct;
        if (t2on && bags.length >= t2.qty) tierPct = t2.pct;
        if (t1.qty > 0 && bags.length < t1.qty) { nextQty = t1.qty; nextPct = t1.pct; }
        else if (t2on && bags.length < t2.qty) { nextQty = t2.qty; nextPct = t2.pct; }
      }

      var lines = [];
      var bagSub = 0, bagPay = 0;
      bags.forEach(function (u, i) {
        var pay = u.price, off = 0;
        if (mode === 'second_bag') {
          if (i % 2 === 1 && secondPct > 0) { off = secondPct; pay = u.price - Math.round(u.price * secondPct / 100); }
        } else if (mode === 'ladder') {
          var lp = ladderPct(i);
          if (lp > 0) { off = lp; pay = u.price - Math.round(u.price * lp / 100); }
        } else if (tierPct > 0) {
          off = tierPct; pay = u.price - Math.round(u.price * tierPct / 100);
        }
        bagSub += u.price;
        bagPay += pay;
        lines.push({ key: u.key, title: u.title, img: u.img, was: u.price, pay: pay, off: off, addon: false });
      });

      var addonSub = 0, addonPay = 0;
      var addonActive = bags.length >= 1;
      addons.forEach(function (u) {
        var pay = addonActive ? accessoryPrice(u) : u.price;
        var off = pay < u.price ? Math.round((u.price - pay) / u.price * 100) : 0;
        addonSub += u.price;
        addonPay += pay;
        lines.push({ key: u.key, title: u.title, img: u.img, was: u.price, pay: pay, off: off, addon: true });
      });

      /* "Was" uses compare at price where the product has one, so the saving
         shown is the total effective discount, not the extra on top of sale. */
      var wasTotal = 0;
      bags.concat(addons).forEach(function (u) { wasTotal += (u.compare > u.price ? u.compare : u.price); });

      var sub = bagSub + addonSub;
      var total = bagPay + addonPay;
      var discount = sub - total;
      var saved = wasTotal - total;
      var savedPct = wasTotal > 0 ? Math.round(saved / wasTotal * 100) : 0;

      var giftOn = cfg.gift && cfg.gift.enabled && cfg.gift.thresholdCents > 0;
      var giftUnlocked = giftOn && total >= cfg.gift.thresholdCents;

      var shipOn = cfg.ship && cfg.ship.enabled && cfg.ship.thresholdCents > 0;
      var shipUnlocked = shipOn && total >= cfg.ship.thresholdCents;

      return {
        bagQty: bags.length, addonQty: addons.length, lines: lines,
        sub: sub, total: total, discount: discount,
        wasTotal: wasTotal, saved: saved, savedPct: savedPct,
        tierPct: tierPct, nextQty: nextQty, nextPct: nextPct,
        giftOn: giftOn, giftUnlocked: giftUnlocked,
        shipOn: shipOn, shipUnlocked: shipUnlocked
      };
    }

    /* ---------------- render ---------------- */
    var XMARK = '<svg viewBox="0 0 8 8" fill="none" aria-hidden="true" focusable="false">' +
      '<path d="M1 1l6 6M7 1L1 7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

    /* Takes ONE unit out of the set, wherever the shopper is standing. Before this the tray
       was decorative: the only way back out was to find the card again in a 47-product grid
       across nine tabs, which is the complaint that started this work.

       It removes one, not all. The first version deleted the whole line, so a shopper with
       three of a bag lost all three to one tap on a control that shows no quantity, with no
       undo. Hajo found it in a minute. One unit per tap is reversible with the card's own +,
       and it is what the summary rail already implies, since that rail lists one row per
       unit. A shopper who wants all three gone taps three times, which is the same cost as
       the mistake used to be. */
    function removeUnit(k) {
      var it = state[k];
      if (!it) return;
      if (it.qty > 1) { it.qty -= 1; } else { delete state[k]; }
      var left = state[k] ? state[k].qty : 0;
      Array.prototype.forEach.call(cards, function (card) {
        if (card.dataset.variant !== k) return;
        var qtyEl = card.querySelector('[data-kv-qty]');
        if (qtyEl) qtyEl.textContent = String(left);
      });
      render();
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-kv-remove]') : null;
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      removeUnit(btn.getAttribute('data-kv-remove'));
    });

    function slotHtml(it) {
      return '<span class="kv-bb__slot">' +
        (it.img ? '<img src="' + escapeHtml(it.img) + '" alt="" loading="lazy">' : '') +
        '</span>';
    }

    function lineHtml(l) {
      var right = l.pay < l.was
        ? '<s>' + formatMoney(l.was) + '</s> <strong>' + formatMoney(l.pay) + '</strong>'
        : '<strong>' + formatMoney(l.pay) + '</strong>';
      return '<li class="kv-bb-line' + (l.pay < l.was ? ' kv-bb-line--off' : '') + '">' +
        '<span class="kv-bb-line__thumb">' + (l.img ? '<img src="' + escapeHtml(l.img) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="kv-bb-line__body">' +
          '<span class="kv-bb-line__title">' + escapeHtml(l.title) + '</span>' +
          (l.off > 0 ? '<span class="kv-bb-line__tag">' + l.off + '% off</span>' : '') +
        '</span>' +
        '<span class="kv-bb-line__price">' + right + '</span>' +
        '<button type="button" class="kv-bb-line__remove" data-kv-remove="' + escapeHtml(l.key) +
          '" aria-label="Remove ' + escapeHtml(l.title) + ' from your set">' + XMARK + '</button>' +
      '</li>';
    }

    var addonJumpLabelEls = root.querySelectorAll('[data-kv-bb-addon-jump-label]');
    var addonJumpBase = addonJumpLabelEls.length ? addonJumpLabelEls[0].textContent : 'Complete your set';

    /* The tab label stays SHORT and never takes the price. "+ Accessories from EUR 9" measured
       270px of a 390px tab row, leaving barely one bag tab beside it, which breaks the thing
       the row is actually for. The price hook lives where there is room for it instead: the
       button under the grid, the tray message, and the chip on every accessory card. */
    function renderAddonPrompts(c) {
      var low = parseInt(cfg.addonLow, 10) || 0;
      setText(addonJumpLabelEls, low > 0 && c.bagQty > 0
        ? addonJumpBase + ', accessories from ' + formatMoney(low)
        : addonJumpBase);
    }

    function render() {
      var c = compute();

      /* Every card showing this variant, not only the card that was tapped. The add-on row
         is printed twice now, in the tab panel and in the foot block, and the two copies
         drifted apart the moment one of them was used: setQty only ever updated its own
         counter. This also fixes the same drift between a card and itself after a variant
         swap, which was there before the row was ever duplicated. */
      each(cards, function (card) {
        var q = card.querySelector('[data-kv-qty]');
        if (q) q.textContent = String(state[card.dataset.variant] ? state[card.dataset.variant].qty : 0);
      });
      var any = c.bagQty + c.addonQty > 0;
      renderAddonPrompts(c);

      /* mobile docked bar: visible only with a selection */
      bar.hidden = !any;
      var barVisible = any && !bar.hidden && bar.offsetHeight > 0;
      document.body.style.paddingBottom = barVisible ? (bar.offsetHeight + 12) + 'px' : '';
      /* consumed by the Alia teaser clearance rule in kv-bundle-builder.css */
      document.documentElement.style.setProperty('--kv-bb-bar-h', barVisible ? bar.offsetHeight + 'px' : '0px');

      /* bar slots: dynamic thumbnails, capped at 5, +N overflow */
      if (slotsEl) {
        var html = '', shown = 0, extra = 0;
        Object.keys(state).forEach(function (k) {
          var it = state[k];
          if (shown < 5) {
            html += '<span class="kv-bb-bar__slot" role="listitem">' +
              (it.img ? '<img src="' + escapeHtml(it.img) + '" alt="" loading="lazy">' : '') +
              (it.qty > 1 ? '<span class="kv-bb-bar__slot-qty">' + it.qty + '</span>' : '') +
              '<button type="button" class="kv-bb-bar__slot-x" data-kv-remove="' + escapeHtml(k) +
                '" aria-label="Remove ' + escapeHtml(it.title) + ' from your set">' + XMARK + '</button>' +
              '</span>';
            shown++;
          } else { extra += it.qty; }
        });
        if (extra > 0) html += '<span class="kv-bb-bar__slot kv-bb-bar__slot--more">+' + extra + '</span>';
        if (c.giftUnlocked && cfg.gift.img) {
          html += '<span class="kv-bb-bar__slot kv-bb-bar__slot--gift"><img src="' + escapeHtml(cfg.gift.img) + '" alt="" loading="lazy"><span class="kv-bb-bar__slot-qty">0</span></span>';
        }
        slotsEl.innerHTML = html;
      }

      /* sidebar: per unit price list (second bag mode) */
      if (linesEl) {
        linesEl.innerHTML = c.lines.map(lineHtml).join('');
        linesEl.hidden = !any;
      }
      if (emptyEl) emptyEl.hidden = any;

      /* sidebar slot rows (tier mode) */
      if (slotRows.length) {
        var units = [];
        Object.keys(state).forEach(function (k) {
          var it = state[k];
          for (var i = 0; i < it.qty; i++) units.push(it);
        });
        var unitIdx = 0;
        each(slotRows, function (row, rowIdx) {
          var cap = parseInt(row.dataset.cap, 10) || 2;
          var isLast = rowIdx === slotRows.length - 1;
          var rowHtml = '';
          for (var i = 0; i < cap; i++) {
            var last = isLast && i === cap - 1;
            var remaining = units.length - unitIdx;
            if (last && remaining > 1) {
              rowHtml += '<span class="kv-bb__slot kv-bb__slot--more">+' + remaining + '</span>';
              unitIdx = units.length;
            } else if (unitIdx < units.length) {
              rowHtml += slotHtml(units[unitIdx]);
              unitIdx++;
            } else {
              rowHtml += '<span class="kv-bb__slot kv-bb__slot--empty"></span>';
            }
          }
          row.innerHTML = rowHtml;
        });
      }

      /* progress message and fill */
      var msg, fill;
      if (c.bagQty === 0 && c.addonQty > 0 && (parseInt(cfg.addonLow, 10) || 0) > 0) {
        msg = 'Add a bag and your accessories drop to ' + formatMoney(parseInt(cfg.addonLow, 10));
        fill = 0;
      } else if (mode === 'second_bag') {
        if (c.bagQty === 0) {
          msg = 'Pick your first bag';
          fill = 0;
        } else if (c.bagQty % 2 === 1) {
          msg = 'Add one more bag and it is ' + secondPct + '% off';
          fill = 50;
        } else {
          var pairs = c.bagQty / 2;
          msg = pairs === 1
            ? 'Your second bag is ' + secondPct + '% off'
            : secondPct + '% off on ' + pairs + ' of your bags';
          fill = 100;
        }
      } else if (mode === 'ladder') {
        var top = ladder.length;
        if (c.bagQty === 0) {
          msg = 'Pick your first bag';
          fill = 0;
        } else if (c.bagQty <= top) {
          var cur = ladderPct(c.bagQty - 1);
          var nxt = ladderPct(c.bagQty);
          msg = (cur > 0 ? 'Bag ' + c.bagQty + ' is ' + cur + '% off. ' : '') + 'Add one more and it is ' + nxt + '% off';
          fill = Math.round(c.bagQty / (top + 1) * 100);
        } else {
          msg = 'Every bag from the 4th is ' + ladder[top - 1] + '% off';
          fill = 100;
        }
      } else if (c.nextQty > 0) {
        var missing = c.nextQty - c.bagQty;
        var noun = missing === 1 ? 'bag' : 'bags';
        if (c.tierPct > 0) {
          msg = c.tierPct + '% off unlocked. Add ' + missing + ' more ' + noun + ' for ' + c.nextPct + '% off';
        } else {
          msg = 'Add ' + missing + ' more ' + noun + ' to unlock ' + c.nextPct + '% off';
        }
        fill = Math.min(100, Math.round(c.bagQty / c.nextQty * 100));
      } else if (c.tierPct > 0) {
        msg = c.tierPct + '% off unlocked';
        fill = 100;
      } else {
        msg = 'Pick your first bag';
        fill = 0;
      }
      setText(msgEls, msg);
      each(fillEls, function (el) { el.style.width = fill + '%'; });

      /* gift line */
      if (c.giftOn) {
        setHidden(giftEls, false);
        if (c.giftUnlocked) {
          setText(giftEls, cfg.gift.label + ': ' + cfg.gift.title + ' unlocked');
        } else {
          setText(giftEls, formatMoney(cfg.gift.thresholdCents - c.total) + ' away from a free ' + String(cfg.gift.title).toLowerCase());
        }
      } else {
        setHidden(giftEls, true);
      }

      /* free shipping progress, measured on the discounted total */
      if (c.shipOn && any) {
        setHidden(shipEls, false);
        each(shipEls, function (el) {
          el.classList.toggle('is-unlocked', c.shipUnlocked);
          el.textContent = c.shipUnlocked
            ? 'Free shipping included'
            : 'Add ' + formatMoney(cfg.ship.thresholdCents - c.total) + ' for free shipping';
        });
      } else {
        setHidden(shipEls, true);
      }

      /* totals */
      if (c.wasTotal > c.total) {
        setHidden(origEls, false);
        setText(origEls, formatMoney(c.wasTotal));
      } else {
        setHidden(origEls, true);
      }
      setText(totalEls, any ? formatMoney(c.total) : '');

      if (any && c.saved > 0) {
        setHidden(savingEls, false);
        setText(savingEls, 'You save ' + formatMoney(c.saved) + ' (' + c.savedPct + '%)');
      } else {
        setHidden(savingEls, true);
      }

      /* CTA enabled state (loading state guards itself) */
      each(ctaEls, function (btn) {
        if (btn.classList.contains('is-loading')) return;
        btn.disabled = !any;
      });
    }

    /* ---------------- add to cart ---------------- */
    function buildItems() {
      var items = [];
      Object.keys(state).forEach(function (k) {
        var it = state[k];
        var props = { _kv_bundle: 'yes' };
        if (it.addon) props._kv_bundle_addon = 'yes';
        items.push({ id: parseInt(k, 10), quantity: it.qty, properties: props });
      });
      var c = compute();
      if (c.giftUnlocked && cfg.gift.variant) {
        items.push({ id: parseInt(cfg.gift.variant, 10), quantity: 1, properties: { _kv_bundle: 'yes', _kv_bundle_gift: 'yes' } });
      }
      return items;
    }

    function resetSelection() {
      state = {};
      Array.prototype.forEach.call(cards, function (card) {
        var qtyEl = card.querySelector('[data-kv-qty]');
        if (qtyEl) qtyEl.textContent = '0';
      });
      render();
    }

    function setCtasDisabled(d) { each(ctaEls, function (b) { b.disabled = d; b.classList.toggle('is-loading', d); }); }

    function submit() {
      var items = buildItems();
      if (!items.length) return;

      setCtasDisabled(true);

      var themeDrawer = document.querySelector('cart-drawer');
      var body = { items: items };
      var headers = { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' };

      if (themeDrawer && window.routes && window.routes.cart_add_url) {
        try {
          body.sections = themeDrawer.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        } catch (e) { /* keep going without drawer sections */ }
      }

      fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          setCtasDisabled(false);
          if (res.status) {
            setCtaLabel('Something went wrong');
            setTimeout(function () { setCtaLabel(ctaDefault); }, 2200);
            render();
            return;
          }
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kv-bundle-builder' });
          }
          if (themeDrawer && body.sections && typeof themeDrawer.renderContents === 'function') {
            themeDrawer.classList.remove('is-empty');
            themeDrawer.renderContents(res);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }
          setCtaLabel('Added \u2713');
          setTimeout(function () { setCtaLabel(ctaDefault); }, 1800);
          resetSelection();
        })
        .catch(function () {
          setCtasDisabled(false);
          setCtaLabel('Something went wrong');
          setTimeout(function () { setCtaLabel(ctaDefault); }, 2200);
          render();
        });
    }

    each(ctaEls, function (btn) {
      btn.addEventListener('click', function () { if (!btn.disabled) submit(); });
    });

    /* ---------------- accessory options: size pills and colour swatches ----------------

       The dropdown is gone from the accessory cards. A select hides every colour but one
       behind a tap, shows a picture of none of them, and on a phone opens a native wheel
       over the whole page. A swatch here is the variant's OWN photograph, so it cannot
       disagree with what arrives, and choosing one swaps the card image, the price, the
       title that reaches the tray and the id that reaches the cart.

       Sizes exist because 13 inch and 16 inch are separate PRODUCTS in this catalogue, not
       options on one product. The section rebuilds the grid of combinations from the
       titles and prints it into a hidden list on the card; everything below just reads it.

       A card can now appear twice on the page, so a pick is mirrored across every card
       carrying the same data-kv-group. Without that the two copies would quietly disagree
       and add different variants to the cart. */
    function comboEls(card) {
      var box = card.querySelector('[data-kv-combos]');
      return box ? box.children : [];
    }

    function findCombo(card, size, colour, prefer) {
      var list = comboEls(card), i;
      for (i = 0; i < list.length; i++) {
        if (list[i].dataset.size === size && list[i].dataset.colour === colour) return list[i];
      }
      /* no exact match: honour whichever control was actually touched */
      for (i = 0; i < list.length; i++) {
        if (prefer === 'size' ? list[i].dataset.size === size : list[i].dataset.colour === colour) return list[i];
      }
      return list.length ? list[0] : null;
    }

    function selectedOpt(card, attr) {
      var el = card.querySelector('[' + attr + '].is-selected');
      if (el) return el.getAttribute(attr);
      var first = comboEls(card)[0];
      if (!first) return '';
      return attr === 'data-kv-opt-size' ? first.dataset.size : first.dataset.colour;
    }

    function applyCombo(card, el) {
      if (!el) return;
      var d = el.dataset;
      var prevKey = card.dataset.variant;
      if (prevKey === d.variant) return;
      var prevQty = state[prevKey] ? state[prevKey].qty : 0;
      if (prevQty > 0) delete state[prevKey];

      card.dataset.variant = d.variant;
      card.dataset.price = d.price;
      card.dataset.compare = d.compare || '0';
      if (d.title) card.dataset.title = d.title;
      card.dataset.img = d.thumb || d.img || '';

      var img = card.querySelector('[data-kv-card-img]');
      if (img && d.img) {
        img.setAttribute('src', d.img);
        img.setAttribute('alt', d.title || '');
      }

      var priceEl = card.querySelector('[data-kv-card-price]');
      if (priceEl) {
        var p = parseInt(d.price, 10) || 0;
        var cmp = parseInt(d.compare, 10) || 0;
        priceEl.innerHTML = (cmp > p ? '<s>' + formatMoney(cmp) + '</s> ' : '') + '<span>' + formatMoney(p) + '</span>';
      }

      var selEl = card.querySelector('[data-kv-card-sel]');
      if (selEl) selEl.textContent = d.size ? d.colour + ' \u00b7 ' + d.size : d.colour;

      each(card.querySelectorAll('[data-kv-opt-size]'), function (b) {
        b.classList.toggle('is-selected', b.getAttribute('data-kv-opt-size') === d.size);
      });

      /* A colour this size does not come in is disabled rather than silently wrong. */
      each(card.querySelectorAll('[data-kv-opt-colour]'), function (b) {
        var c = b.getAttribute('data-kv-opt-colour');
        b.classList.toggle('is-selected', c === d.colour);
        var ok = false, list = comboEls(card), i;
        for (i = 0; i < list.length; i++) {
          if (list[i].dataset.colour === c && list[i].dataset.size === d.size) { ok = true; break; }
        }
        b.disabled = !ok;
      });

      /* Carry the quantity across to the new variant, adding to whatever is already
         selected in that colour rather than overwriting it. */
      if (prevQty > 0) {
        var held = state[card.dataset.variant];
        state[card.dataset.variant] = {
          qty: Math.min(20, prevQty + (held ? held.qty : 0)),
          price: parseInt(card.dataset.price, 10) || 0,
          compare: parseInt(card.dataset.compare, 10) || 0,
          title: card.dataset.title || '',
          img: card.dataset.img || '',
          addon: card.dataset.addon === '1',
          setPrice: parseInt(card.dataset.setPrice, 10) || 0
        };
      }
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-kv-opt-size],[data-kv-opt-colour]') : null;
      if (!btn || !root.contains(btn) || btn.disabled) return;
      var card = btn.closest('[data-kv-item]');
      if (!card) return;
      e.preventDefault();

      var isSize = btn.hasAttribute('data-kv-opt-size');
      var size = isSize ? btn.getAttribute('data-kv-opt-size') : selectedOpt(card, 'data-kv-opt-size');
      var colour = isSize ? selectedOpt(card, 'data-kv-opt-colour') : btn.getAttribute('data-kv-opt-colour');
      var group = card.dataset.kvGroup;

      each(cards, function (c2) {
        if (group ? c2.dataset.kvGroup !== group : c2 !== card) return;
        applyCombo(c2, findCombo(c2, size, colour, isSize ? 'size' : 'colour'));
      });
      render();
    });

    /* ---------------- tabs ---------------- */
    var addonFoot = root.querySelector('[data-kv-bb-addon-foot]');
    var tabs = root.querySelectorAll('[data-kv-bb-tab]');
    Array.prototype.forEach.call(tabs, function (tab) {
      tab.addEventListener('click', function () {
        Array.prototype.forEach.call(tabs, function (t) {
          /* Compare the TARGET, not the element. The buttons under each bag grid point at
             the accessories panel too, so identity comparison took the active state off
             the pinned pill the moment anyone arrived through one of them. */
          var on = t.dataset.kvBbTab === tab.dataset.kvBbTab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        var panels = root.querySelectorAll('[data-kv-bb-panel]');
        var active = null;
        Array.prototype.forEach.call(panels, function (p) {
          p.hidden = p.dataset.kvBbPanel !== tab.dataset.kvBbTab;
          if (!p.hidden) active = p;
        });
        /* The foot block holds the same cards. Showing both would print the accessories
           twice on one screen. */
        if (addonFoot) addonFoot.hidden = tab.dataset.kvBbTab === 'kvbb-addons';
        if (active && active.getBoundingClientRect().top < 0) {
          active.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    /* The spacer is the pinned STRIP's own width, measured rather than guessed, so the pill
       comes to rest on empty space at the end of the scroll instead of on a bag tab. */
    var addonTabEl = root.querySelector('[data-kv-bb-tab-pin]') || root.querySelector('[data-kv-bb-addon-tab]');
    var tabSpacer = root.querySelector('[data-kv-bb-tab-spacer]');
    if (addonTabEl && tabSpacer) {
      var sizeSpacer = function () {
        var w = addonTabEl.offsetWidth;
        if (w > 0) tabSpacer.style.width = (w + 8) + 'px';
      };
      sizeSpacer();
      window.addEventListener('resize', sizeSpacer);
      if (window.requestAnimationFrame) window.requestAnimationFrame(sizeSpacer);
    }

    render();

    /* keep the body padding mirror honest when the bar resizes */
    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        var visible = !bar.hidden && bar.offsetHeight > 0;
        if (visible) document.body.style.paddingBottom = (bar.offsetHeight + 12) + 'px';
        document.documentElement.style.setProperty('--kv-bb-bar-h', visible ? bar.offsetHeight + 'px' : '0px');
      }).observe(bar);
    }

    /* exposed for the QA harness and for Intelligems arm scripts */
    root.kvBbCompute = compute;
  }

  function boot() {
    document.querySelectorAll('[data-kv-bundle-builder]').forEach(init);
    initUspSlider();
  }

  /* USP bar below the hero: Splide on mobile, destroyed at 750px and above
     (same config family as kv-usp-slider.js). The splide__slide class is
     added here at mount so the no-JS markup stays a plain scrollable row. */
  function initUspSlider() {
    var root = document.querySelector('[data-kv-bb-usp-slider]');
    if (!root || root.__kvSplide) return;
    if (typeof Splide === 'undefined') {
      window.addEventListener('load', initUspSlider, { once: true });
      return;
    }
    var items = root.querySelectorAll('.kv-bb__usp');
    if (!items.length) return;
    items.forEach(function (el) { el.classList.add('splide__slide'); });
    var splide = new Splide(root, {
      mediaQuery: 'min',
      type: 'slide',
      rewind: true,
      rewindByDrag: true,
      perPage: 1,
      gap: '14px',
      arrows: false,
      pagination: false,
      autoplay: true,
      interval: 3000,
      speed: 450,
      pauseOnHover: true,
      breakpoints: { 750: { destroy: true } }
    });
    /* progress bar instead of dots: light gray dots vanished on the gray
       strip. Fill width tracks the active index over the real end index. */
    var fill = root.querySelector('.kv-bb__uspbar-progress-fill');
    if (fill) {
      var paint = function () {
        var end = splide.Components.Controller.getEnd() + 1;
        fill.style.width = String(100 * (splide.index + 1) / end) + '%';
      };
      splide.on('mounted move', paint);
    }
    root.__kvSplide = splide.mount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
